import React from 'react';
import { MapPin, ChevronRight, Check } from 'lucide-react';
import { interests } from '../data/interests';

const UserProfileView = ({ selectedUser, currentUser, setCurrentView, onSendMessage }) => {
  if (!selectedUser) return null;
  
  return (
    <div className="max-w-4xl mx-auto p-4">
      {/* Back button */}
      <button
        onClick={() => setCurrentView('map')}
        className="mb-4 flex items-center space-x-2 text-gray-600 hover:text-gray-800"
      >
        <ChevronRight className="w-4 h-4 rotate-180" />
        <span>Back to Map</span>
      </button>

      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Profile Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 p-8 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-6">
              <div className="bg-white/20 rounded-full p-2">
                <img src={selectedUser.avatar} alt={selectedUser.name} className="w-20 h-20 rounded-full object-cover" />
              </div>
              <div>
                <h1 className="text-3xl font-bold mb-2">{selectedUser.name}</h1>
                <p className="flex items-center text-red-100">
                  <MapPin className="w-4 h-4 mr-1" />
                  {selectedUser.location}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Content */}
        <div className="p-8">
          {/* Bio Section */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">About</h3>
            <p className="text-gray-700">{selectedUser.bio}</p>
          </div>

          {/* Interests Section */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Interests</h3>
            <div className="flex flex-wrap gap-3">
              {selectedUser.interests.map(interest => {
                const interestData = interests.find(i => i.id === interest);
                if (!interestData) return null;
                const Icon = interestData.icon;
                const hasMatch = currentUser?.interests.includes(interest);
                
                return (
                  <span
                    key={interest}
                    className={`flex items-center space-x-2 px-4 py-2 rounded-full ${
                      hasMatch
                        ? 'bg-green-50 text-green-700 border border-green-200'
                        : 'bg-red-50 text-red-600 border border-red-200'
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                    <span>{interestData.label}</span>
                    {hasMatch && <Check className="w-3 h-3 ml-1" />}
                  </span>
                );
              })}
            </div>
          </div>

          {/* Social Links */}
          {(selectedUser.socials?.instagram || selectedUser.socials?.linkedin) && (
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Connect</h3>
              <div className="flex space-x-4">
                {selectedUser.socials.instagram && (
                  <a href="#" className="text-gray-600 hover:text-red-600">
                    Instagram: @{selectedUser.socials.instagram}
                  </a>
                )}
                {selectedUser.socials.linkedin && (
                  <a href="#" className="text-gray-600 hover:text-red-600">
                    LinkedIn
                  </a>
                )}
              </div>
            </div>
          )}

          {/* Contact Actions */}
          <div className="flex space-x-4">
            <button 
              onClick={() => onSendMessage(selectedUser)}
              className="flex-1 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors font-semibold"
            >
              Send Message
            </button>
            <button className="flex-1 py-3 border-2 border-red-600 text-red-600 rounded-xl hover:bg-red-50 transition-colors font-semibold">
              Save Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileView;